import { combineReducers } from 'redux';
import posts from './postsReducer';
import login from './loginReducer';
import topUsers from './topUsersReducer';

const rootReducer = combineReducers({
    posts,
    login,
    topUsers
});

export default rootReducer;